import React from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';

import App from './App';
import * as serviceWorker from './serviceWorker';
import reducer from './store/reducer';
import config from './config';
import axios from 'axios';
//import { requireLogin  } from "./services/auth";


const store = createStore(reducer);

const app = (
    <Provider store={store}>
        <BrowserRouter basename={config.basename}>            
            <App />
        </BrowserRouter>
    </Provider>
);

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    const token = localStorage.getItem('sia-token');
    //console.log('Requisição no request...');
    //console.log(config);
    //Verifica se está autenticado
    
    if (config.url.includes("cad-painel-get-unidades") || config.url.includes("cad-painel-get-paineis") || config.url.includes("cad-painel-get-config") || config.url.includes("cad-painel-get-chamado")){
        //console.log('Ativação do Painel ...')
    }
    else
    {
        //requireLogin();
    }
        

    

    if (token) {
        //console.log('vai colocar o token ;...')
        //request.headers.common.Authorization = `Bearer ${token}`;
    }

    // Do something before request is sent
   
     if (document.getElementById('load_data'))
     document.getElementById('load_data').className = 'cover-spin';
     return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    //console.log('Resposta ...');
    // Do something with response data
    if (document.getElementById('load_data'))
       document.getElementById('load_data').className = 'cover-spin_close';
       return response;
  }, function (error) {
    // Do something with response error
    return Promise.reject(error);
  }); 

ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
